import { useMutation } from "react-query";
import HttpService from "../../services/http";
import { AxiosError } from "axios";

interface WalletPassParams {
  processId: string;
  userIdentification: string;
}

export const useGetAppleWalletPass = () => {
  return useMutation<Blob, AxiosError<any, any>, WalletPassParams>(
    async ({ processId, userIdentification }) => {
      const res = await HttpService.get(
        `/entity/lmc/wallet-pass/${processId}/${userIdentification}`,
        { responseType: "blob" }
      );
      return res.data;
    }
  );
};

export const useGetGoogleWalletPassUrl = () => {
  return useMutation<string, AxiosError<any, any>, WalletPassParams>(
    async ({ processId, userIdentification }) => {
      const res = await HttpService.get(
        `/entity/lmc/google-wallet-pass/${processId}/${userIdentification}`
      );
      return res.data.url;
    }
  );
};
